<template>
  <div class="px-box-4 first:mt-box-4 last:mb-box-4 my-12">
    <div class="flex items-center">
      <svg role="presentation" focusable="false" tabindex="-1" class="icon"   alt="" svg-inline  xmlns="http://www.w3.org/2000/svg" width="29" height="40" fill="none">
  <path fill="#FFB84F" d="M1.3 3.9h26.4c.5 0 .9.4.9.9v33.3c0 .5-.4.9-.9.9H1.3a.9.9 0 0 1-.9-.9V4.8c0-.5.4-.9.9-.9Z"/>
  <path fill="#FF7436" d="M23.4 1.8H6.6c-.7 0-1.3.6-1.3 1.3v2.7c0 .7.6 1.3 1.3 1.3h16.8c.7 0 1.3-.6 1.3-1.3V3.1c0-.7-.6-1.3-1.3-1.3Z"/>
  <path fill="#FF7436" d="M15 5.2A2.6 2.6 0 1 0 15 0a2.6 2.6 0 0 0 0 5.2Z"/>
  <path fill="#fff" d="M12.8 13.7H7.2c-.5 0-.9.4-.9.9v5.7c0 .5.4.9.9.9h5.6c.5 0 .9-.4.9-.9v-5.7c0-.5-.4-.9-.9-.9Zm0 13.5H7.2c-.5 0-.9.4-.9.9v5.7c0 .5.4.9.9.9h5.6c.5 0 .9-.4.9-.9v-5.7c0-.5-.4-.9-.9-.9Z"/>
  <path fill="#FF5B05" fill-rule="evenodd" d="M18 10.6c.6.6.7 1.6 0 2.3l-6 6.7a1.6 1.6 0 0 1-2.2 0L7 17a1.6 1.6 0 0 1 2.2-2.2l1.5 1.5 5-5.5c.5-.6 1.5-.7 2.2 0Z" clip-rule="evenodd"/>
</svg>
      <SliceTitle class="subtitle1 ml-4" :value="content.title" />
    </div>
    <PortableText
      v-if="content.optionalDescription"
      class="typography mt-4"
      :content="content.optionalDescription"
    />
    <ul>
      <li v-for="item in items" :key="item.title" class="mt-6 flex">
        <input
          name="checkbox"
          class="w-6 h-6 mr-4 shrink-0 mt-1"
          type="checkbox"
          :value="item.title"
          :checked="checklistState.get(item.title) ?? false"
          @input="onChange(item.title, ($event.target as HTMLInputElement)?.checked)"
        />
        <div>
          <p class="subtitle2">{{ item.title }}</p>
          <PortableText v-if="item.optionalDescription" :content="item.optionalDescription" />
          <a
            v-if="item.optionalLink"
            class="link block"
            :href="item.optionalLink.link ?? undefined"
          >
            {{ item.optionalLink.label || $t('read_more') }}
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { ChecklistItemClick } from '@core/analytics/core-events/checklist'
import type { GQLChecklistSlice } from './generated/checklist'

const props = defineProps<{ content: GQLChecklistSlice }>()
const items = computed(() => {
  return props.content.checklist.filter(({ title }) => !hasInvalidPlaceholderValue(title))
})

const checklistState = ref<Map<string, boolean>>(new Map())
const CHECKLIST_STORAGE_PREFIX = 'checklist'
onMounted(async () => {
  const storedValue =
    (await storage.getValue(`${CHECKLIST_STORAGE_PREFIX}.${props.content.id}`)) || {}

  checklistState.value = new Map(Object.entries(storedValue))
})

const { $track } = useNuxtApp()
async function onChange(title: string, checked: boolean) {
  if (checked) {
    checklistState.value.set(title, checked)
    await $track(
      ChecklistItemClick({
        checklistId: props.content.id,
        checklistTitle: props.content.title.text,
        checklistItemTitle: title,
      }),
    )
  } else {
    checklistState.value.delete(title)
  }

  await storage.setValue(
    `${CHECKLIST_STORAGE_PREFIX}.${props.content.id}`,
    Object.fromEntries(checklistState.value),
  )
}
</script>
